<fieldset>
  <div class="column-100">
      <gmt-input label="Datum zamítnutí správní žaloby" required="true">
        <input type="text" pick-a-date [(ngModel)]="data.expropriationAdministrativeAppealRejectedDate" [maxToday]="true"/>
      </gmt-input>
  </div>
</fieldset>
